import { Search } from "@/atoms"

import styles from "./SearchQuickFilter.module.scss"

import type { QuickFilterDropdownProps } from "../.."

export const SearchQuickFilter = (
  props: QuickFilterDropdownProps,
  onSearch: (value: string) => void
) => {
  const { allowSearch, items } = props

  if (!items) return []

  const shouldUseSearch = allowSearch && items.length > 6

  if (!shouldUseSearch) return []

  return [
    {
      key: "search",
      label: <Search className={styles.search} onSearch={onSearch} />
    },
    { key: "search_divider", type: "divider" as const }
  ]
}
